import './src/components/Layout/Globals.css';

// Cookieless visitor counter in NOVA (module "visits"). onRouteUpdate also
// fires on the first page load, so every page view is counted exactly once.
export const onRouteUpdate = ({ location, prevLocation }) => {
  try {
    fetch('https://nova.innomega.se/app/visit-track.bxm?site=voltodiluce', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        p: location.pathname,
        r: prevLocation ? '' : document.referrer,
        q: location.search,
        l: navigator.language,
      }),
    });
  } catch (e) {}
};
